

































































































































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/SolicitudStock/FiltrosBusqueda.vue';
import ModalCrear from '@/pantallas/Conecta/SolicitudStock/ModalCrear.vue';
import ModalAsignacion from '@/pantallas/Conecta/SolicitudStock/ModalAsignacion.vue';

import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent, actionsEvent_2 } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';

import { fetchMS } from '@/pantallas/Conecta/SolicitudStock/fetchMS';

import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';

import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import Confirmation from '@/components/Confirmation.vue';
import ModalSeries from './ModalSeries.vue';
import ModalVerEstadoSeries from './ModalVerEstadoSeries.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    ModalCrear,
    ModalAsignacion,
    Confirmation,
    ModalSeries,
    ModalVerEstadoSeries,
  },
})
export default class SolicitudStock extends ComponenteBase {
  readonly codigoAccionesMenuItem = Object.values(codigoAccionesMenuItem);
  readonly funcionalidad: Funcionalidades = Funcionalidades.SolicitudStock;
  readonly loadingService = new LoadingService();
  pagina: number = 1;
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  filtrobusquedagrilla: string = '';
  listaReq: any[] = [];
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any = null;
  gridApi: GridApi = null;
  showReporteGenerado: boolean = false;
  dialogVerEstadoSerie: boolean = false;
  texto_reporte: string = '';
  showModalNew: boolean = false;
  showModalAsignacion: boolean = false;
  registroSeleccionado: any = {
    asignumero: '',
    modalidad: '',
    estado: '',
    modalidadid: '',
    asigcreacion_auto: '',
  };
  estadosList: any[] = [];
  razonsocialList: any[] = [];

  dialogConfirmacionGuardar: boolean = false;
  mensajeConfirmacion: any = '';
  dialogConfirmacionGuardar2: boolean = false;
  mensajeConfirmacion2: any = '';

  dialogSerieList: boolean = false;
  data: any = {};
  scrollcopiado: boolean = false;

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
    notestado: {
      label: 'Excluir Estado',
      id: '',
      value: [],
    },
    requerimiento: {
      label: 'Requerimiento',
      id: 'requerimiento',
      value: '',
    },
    razonsocial: {
      label: 'Cliente',
      id: '',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: '',
    },
    fechaFin: {
      label: 'Fecha Fin',
      id: 'fechaFin',
      value: '',
    },
  };

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Número',
        field: 'asignumero',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Fecha',
        field: 'asigfecha_alta',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Requerimiento',
        field: 'asigrequerimiento',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'ADP',
        field: 'asigcrm_adp',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'RUT Cliente',
        field: 'rut_cliente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 90,
      },
      {
        headerName: 'Cliente',
        field: 'cliente',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 130,
      },
      {
        headerName: 'Modalidad',
        field: 'modalidad',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 100,
      },
      {
        headerName: 'Flota',
        field: 'asigcrm_flota',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Tipo Flota',
        field: 'ndvtipo_flota',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Orden de Compra',
        field: 'asigordencompra',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Mandante',
        field: 'asigmandanterut',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Alta',
        field: 'asigcrm_alta',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Estado',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Tipo Creación',
        field: 'asigcreacion_auto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Porcentaje Finalización',
        field: 'porcentaje_serie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
      {
        headerName: 'Glosa Integración',
        field: 'glosa_integracion',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 170,
      },
    ],
    pagination: true,
    paginationPageSize: this.cant_regs_pag,
    cacheBlockSize: this.cant_regs_pag,
    paginationAutoPageSize: false,
    rowModelType: 'serverSide',
    serverSideDatasource: this.serverSide,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    onSelectionChanged: this.onSelectionChanged,
    overlayNoRowsTemplate: 'No hay filas para mostrar',
    processCellForClipboard: ({ value }) =>
      value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value,
  };

  async handleGridReady(event: GridReadyEvent) {
    this.get_estados();
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = event.request.startRow / self.cant_regs_pag + 1;
        let body: any = self.filtros2body();
        body.pagina = self.pagina;
        body.hashpaginacion = self.hashpaginacion;
        body.pantalla = 'solicitud-stock';
        body.request = event.request;
        self.loadingService.showLoading(undefined, 'grillaPreparacion');

        fetchMS(body, 'get')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.LISTA.length === 0) {
                self.$snotify.error('Sin registros', { timeout: 3000 });
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
              } else {
                event.successCallback(
                  response.data.data.LISTA,
                  response.data.data.TOTAL_REGISTROS
                );
                self.hashpaginacion = response.data.data.hash1;
                self.rowcount =
                  response.data.rowcount === null ? 0 : response.data.rowcount;
                self.total_registros =
                  response.data.data.TOTAL_REGISTROS === null ||
                  response.data.data.TOTAL_REGISTROS === undefined
                    ? 0
                    : response.data.data.TOTAL_REGISTROS;

                self.cant_regs_pag =
                  response.data.data.cant_regs_pag === null ||
                  response.data.data.cant_regs_pag === undefined
                    ? 50
                    : response.data.data.cant_regs_pag;
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
              }
            } else {
              event.successCallback([{}], 0);
              self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading('grillaPreparacion');
          });
      },
    };
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  async get_estados() {
    let self = this;
    return fetchMS({ '': '' }, 'get_estados')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          self.estadosList = response.data.LOCALIDAD;
          self.razonsocialList = response.data.RAZONSOCIAL;
        } else {
          self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })

      .catch((error: any) => {
        if (error.message == 'Network Error') {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los estados',
            { timeout: 3000 }
          );
        } else if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los estados',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => {
        return null;
      });
  }
  handleCierreModalCrear() {
    actionsEvent.removeListeners();
    this.actions();
    this.showModalNew = false;
    this.hashpaginacion = '';
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  handleCierreModalAsignacion() {
    actionsEvent.removeListeners();
    this.actions();
    this.showModalAsignacion = false;
    this.dialogSerieList = false;
    this.dialogVerEstadoSerie = false;
    this.data = {};
    this.registroSeleccionado = {};
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  filtros2body() {
    let body: any = {};

    let fechaInicio: any;
    let fechaFin: any;
    if (moment.isMoment(this.formFields.fechaInicio.value)) {
      fechaInicio = moment(this.formFields.fechaInicio.value).format('L');
    }
    if (moment.isMoment(this.formFields.fechaFin.value)) {
      fechaFin = moment(this.formFields.fechaFin.value).format('L');
    }
    body.fecha_inicio = fechaInicio;
    body.fecha_fin = fechaFin;
    body.requerimiento = this.formFields.requerimiento.value;
    body.estado = this.formFields.estado.value;
    body.razonsocial = this.formFields.razonsocial.value;
    body.notestado = this.formFields.notestado.value;
    return body;
  }

  filtroAlertas(loadWidget: boolean) {
    this.hashpaginacion = '';
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  async AlertaInicial() {
    this.hashpaginacion = '';
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  onSelectionChanged(params: any) {}

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  async btn_exportar(tipo: string) {
    let body: any = this.filtros2body();
    body.extension = 'csv';
    this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchMS(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'Reporte Preparación de Equipos',
        tipo: tipo,
      },
      'exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');

        this.texto_reporte = data.data.MENSAJE_RESPUESTA;

        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }

  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }

  accionVerDetalle: PermisoAccion = {
    accionCodigo: 3,
    visible: false,
  };
  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionCrear, this.accionVerDetalle];

  handleVerDetalleClick(params: ICellRendererParams) {
    this.registroSeleccionado = params.data;
    this.data = { ...params.data };
    this.showModalAsignacion = true;
  }
  handleCierreModalVerDetalle() {
    //this.mostrarModalVerDetalle = false;
  }

  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }

  actions() {
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);
    actionsEvent.onFinalizar(this.handleFinalizarClick);
  }

  constructor() {
    super();
    this.actions();
  }
  reg_por_finalizar: any = null;
  async handleFinalizarClick(params: ICellRendererParams) {
    /*if (params.data.estado == 'Por preparar') {
      this.$snotify.warning(
        'El requerimiento no cuenta con equipos preparados, no es posible Finalizar',
        { timeout: 3000 }
      );
    }*/

    const validateDataToFinish: boolean = await this.validateDataToFinish(
      params.data
    );

    if (validateDataToFinish) {
      this.mensajeConfirmacion =
        '¿Está seguro que desea finalizar este requerimiento? ';
      this.dialogConfirmacionGuardar = true;
      this.reg_por_finalizar = params;
    } else {
      this.reg_por_finalizar = null;
    }
  }
  async handleConfirmacionGuardar(val: boolean) {
    if (!val) {
      this.dialogConfirmacionGuardar = false;
      this.reg_por_finalizar = null;
    } else {
      const validate_finalizar_reserva: boolean = await this.finalizar_reserva(
        this.reg_por_finalizar.data
      );
      if (validate_finalizar_reserva) {
        this.dialogConfirmacionGuardar = false;
        this.$snotify.success(
          'Asignación Nro. ' +
            this.reg_por_finalizar.data.asignumero +
            ' finalizada correctamente',
          { timeout: 5000 }
        );
        this.filtroAlertas(true);
        this.handleCierreModalAsignacion();
      }
    }
  }

  handleVerEstadoSeries(params: ICellRendererParams) {
    console.log('params', params.data);
    this.dialogVerEstadoSerie = true;
    this.data = { ...params.data };
  }

  async finalizar_reserva(data: any) {
    try {
      this.loadingService.showLoading(undefined, 'finalizar_reserva');
      const result = await fetchMS({ ...data }, 'finalizar_reserva');
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      return CODIGO_RESPUESTA === '1' ? true : false;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
      } else {
        this.$snotify.error(
          'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
          { timeout: 3000 }
        );
      }
      return false;
    } finally {
      this.loadingService.hideLoading('finalizar_reserva');
    }
  }

  async validateDataToFinish(data: any) {
    try {
      this.loadingService.showLoading(undefined, 'validateDataToFinish');
      const result = await fetchMS(
        { ...data },
        'validate_data_to_finish_manual'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      return MENSAJE_RESPUESTA === 'OK' ? true : false;
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
      } else {
        this.$snotify.error(
          'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
          { timeout: 3000 }
        );
      }
      return false;
    } finally {
      this.loadingService.hideLoading('validateDataToFinish');
    }
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  mounted() {
    this.copy_scroll();
  }

  copy_scroll() {
    let copyscroll = setInterval(() => {
      const headers = document.querySelectorAll<HTMLElement>(
        '.preparacionscroll .ag-root-wrapper-body .ag-body-horizontal-scroll'
      );
      if (headers.length > 1) {
        headers[0].remove();
      }
      if (headers.length === 1) {
        const clonedHeader = headers[0].cloneNode(true) as HTMLElement;
        clonedHeader.classList.add('sticky-scroll'); // Agregar la clase para fijar el elemento al hacer scroll
        const rootWrapper = document.querySelector<HTMLElement>(
          '.preparacionscroll .ag-root-wrapper-body .ag-root.ag-unselectable.ag-layout-auto-height'
        );
        if (rootWrapper === null) {
          return;
        }
        rootWrapper.prepend(clonedHeader);

        // Sincronizar el scroll horizontal entre el header clonado y el original
        const scrollViewports = document.querySelectorAll<HTMLElement>(
          '.preparacionscroll .ag-root-wrapper-body .ag-body-horizontal-scroll-viewport'
        );
        scrollViewports[0].addEventListener('scroll', function() {
          scrollViewports[1].scrollLeft = scrollViewports[0].scrollLeft;
        });
        scrollViewports[1].addEventListener('scroll', function() {
          scrollViewports[0].scrollLeft = scrollViewports[1].scrollLeft;
        });
      }
      // Sincronizar los espaciadores
      const rightSpacers = document.querySelectorAll<HTMLElement>(
        '.preparacionscroll .ag-root-wrapper-body .ag-horizontal-right-spacer'
      );
      rightSpacers[0].style.width = rightSpacers[1].style.width;
      rightSpacers[0].style.minWidth = rightSpacers[1].style.minWidth;
      rightSpacers[0].style.maxWidth = rightSpacers[1].style.maxWidth;

      const scrollContainer = document.querySelectorAll<HTMLElement>(
        '.preparacionscroll .ag-root-wrapper-body .ag-body-horizontal-scroll-container'
      );
      scrollContainer[0].style.width = scrollContainer[1].style.width;
      scrollContainer[0].style.minWidth = scrollContainer[1].style.minWidth;
      scrollContainer[0].style.maxWidth = scrollContainer[1].style.maxWidth;

      this.scrollcopiado = true;
      clearInterval(copyscroll);
    }, 1000);
  }
}
